import axiosClient from "../../../shared/lib/axiosClient";
import type {
    ApiResult,
    LoginPayload,
    RegisterPayload,
    RequestOtpPayload
} from "../types";

// Shared POST helper: every auth endpoint returns an ApiResult
const post = async (url: string, body: object): Promise<ApiResult> => {
    const { data } = await axiosClient.post<ApiResult>(url, body);
    return data;
};

// Sends an SMS code to the phone number (protected by reCAPTCHA)
export const requestOtp = (payload: RequestOtpPayload) =>
    post("/web-auth/request-otp", payload);

export const login = (payload: LoginPayload) => post("/web-auth/login", payload);

export const register = (payload: RegisterPayload) =>
    post("/web-auth/register", payload);